import React, { Component } from 'react'
import { Confirm, ModalContent } from 'semantic-ui-react'

export default class ConfirmModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            open: false,
            header: this.props.header ? this.props.header : null,
            content: this.props.content ? this.props.content : '',
            buttonConfirm: this.props.buttonConfirm ? this.props.buttonConfirm : 'OK',
            buttonCancel: this.props.buttonCancel ? this.props.buttonCancel : 'Cancel',
            onCancel: this.props.onCancel ? this.props.onCancel : null,
            onConfirm: this.props.onConfirm ? this.props.onConfirm : null,
            canClose: true,
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.open !== this.props.open){
            this.setState({
                open: this.props.open
            });
        }
    }

    makeWide() {
        this.setState({size: 'large'})
    }

    reset() {
        this.setState({
            open: false,
            header: null,
            content: '',
            buttonConfirm: 'OK',
            buttonCancel: 'Cancel',
            onCancel: null,
            onConfirm: null,
            canClose: true,
        });
    }
    setOpen = () => {
        this.setState({open:true})
    };
    setClose = () => {
        this.reset()
    };
    setContent = (content) => {
        this.setState({content: content})
    };
    setButtonConfirm = (button) => {
        this.setState({buttonConfirm: button})
    };
    setButtonCancel = (button) => {
        this.setState({buttonCancel: button})
    };
    setOnCancel = (callback) => {
        this.setState({onCancel: callback})
    };
    setOnConfirm = (callback) => {
        this.setState({onConfirm: callback})
    };
    setHeader = (header) => {
        this.setState({header: header})
    };

    setCantClose = () => {
        this.setState({ canClose: false })
    };

    onCancel = () => {
        this.setState({open: false});
        if (typeof this.state.onCancel === 'function')
            this.state.onCancel()
    };
    onConfirm = () => {
        this.setState({open: false});
        if (typeof this.state.onConfirm === 'function')
            this.state.onConfirm()
    };

    render() {
        return (
            <div>
                <Confirm
                    size={this.state.size}
                    closeOnEscape={ this.state.canClose }
                    closeOnDimmerClick={ this.state.canClose }
                    header={ this.state.header }
                    content={ <ModalContent>{ this.state.content }</ModalContent>}
                    open={ this.state.open }
                    onCancel={ this.onCancel }
                    onConfirm={ this.onConfirm }
                    cancelButton={ this.state.buttonCancel }
                    confirmButton={ this.state.buttonConfirm }
                    dimmer='inverted'
                />
            </div>
        )
    }
}